import React, { Component } from 'react'
import classes from './Tag.module.css'

export default class Tag extends Component {
  render() {
    return <div className={classes.el}>{this.props.name}</div>
  }
}
